import {
	collection,
	where,
	query,
	getDocsFromServer,
	limit,
	FieldPath,
	getDocFromServer,
	doc,
	getDoc,
	DocumentId,
	setDoc,
} from 'firebase/firestore';
import { db } from '@/firebase';
import { useAuthStore } from '@/v2/store/shared/auth-store';
import { useChatsStore } from './stores/chats';
import { api } from '@/v2/plugins/axios';

const configEndpoint = process.env.MIX_FUNCTION_URL_FIRESTORE_REGISTER_TENANT;

export class WhatsAppService {
	static async getFirebaseTenantConfig() {
		const authStore = useAuthStore();

		// const chatsStore = useChatsStore();
		// await chatsStore.authenticateWithFirebase();

		const tenantId = authStore.tenantId;
		const docRef = doc(db, 'tenants', `${tenantId}`);
		const res = (await getDocFromServer(docRef)).data();
		return res?.configs || {};
	}

	static setConfig(data) {
		return api.post(configEndpoint, data);
	}

	static async getConfig() {
		const authStore = useAuthStore();
		const tenantId = authStore.tenantId;
		const docRef = doc(db, 'tenants', `${tenantId}`);
		const res = (await getDocFromServer(docRef)).data();
		return res || {};
	}

	static async getEduFirebaseTenantData() {
		const authStore = useAuthStore();

		const tenantId = authStore.tenantId;
		const docRef = doc(eduDb, 'tenants', `${tenantId}`);
		const res = (await getDocFromServer(docRef)).data();
		return res || {};
	}

	static async setEduFirebaseTenantData(data) {
		const authStore = useAuthStore();

		const tenantId = authStore.tenantId;
		const docRef = doc(eduDb, 'tenants', `${tenantId}`);
		await setDoc(docRef, data, { merge: true });
	}
}
